export default {
    values: {
        'Final PFD': 'PFD final',
        'Value max': 'Valor max',
        'Value min': 'Valor min',
        'Initial PFD': 'PFD Inicial',
        Maximum: 'Máximo',
        Minimum: 'Mínimo',
        'Values out of this range will not be considered.': 'Valores fora desta faixa não serão considerados.',
        Units: 'Unidades',
        'Validation Range': 'Faixa de validação',
        channel: 'canal',
        Channel: 'Canal',
        'channel ID': 'ID do canal',
        'channel initial PFD': 'PFD inicial do canal',
        'channel min interval': 'intervalo min do canal',
        'channel max interval': 'intervalo max do canal',
        'channel validation interval': 'intervalo de validação do canal',
        rule: 'regra',
        'resultant PFD': 'PFD resultante',
        'resultant PFD should not be more than 1': 'PFD resultante não pode ser maior que 1',
        'channel rules': 'regras do canal',
        'Initial PFD (Probability of Failure on Demand)': 'PFD Inicial (Probabilidade de Falha sob Demanda)'
    }
}
